import { OnInit, Component, inject } from '@angular/core';
import { VersionService, I18NText } from '../core/api';
import { environment } from '../../environments/environment';
import { NgbActiveModal, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { ClientConfigDBService } from '../core/db/client-config-db-service';
import { TranslateDirective } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { AutofocusDirective } from '../autofocus/autofocus.directive';
import { I18nTextPipe } from '../core/pipes/i18n-text.pipe';

@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.component.html',
  imports: [TranslateDirective, NgClass, NgbCollapse, AutofocusDirective, I18nTextPipe],
})
export class AboutDialogComponent implements OnInit {
  protected modal = inject(NgbActiveModal);
  private versionService = inject(VersionService);
  private clientConfigDBService = inject(ClientConfigDBService);

  public acmobileAbout: I18NText | null = null;
  public acmobileServicesVersion: string | null | undefined;
  public acmobileClientVersion: string | null | undefined;
  public inspectionTypeConfigVersion: string | null | undefined;
  public categoryConfigVersion: string | null | undefined;
  public pointToCategoryMappingConfigVersion: string | null | undefined;
  public pointToPointGroupMappingConfigVersion: string | null | undefined;
  public pointConfigVersion: string | null | undefined;
  public clientConfigVersion: string | null | undefined;
  public versionInfoCollapsed = true;

  public ngOnInit(): void {
    this.acmobileClientVersion = environment.acmobileClientVersion;
    this.versionService.apiVersionGet().subscribe(
      (version) => {
        this.acmobileServicesVersion = version;
      },
      () => {},
    );
    this.clientConfigDBService.getInspectionTypeConfig().subscribe(
      (config) => {
        if (config) {
          this.inspectionTypeConfigVersion = config.version;
        }
      },
      () => {},
    );
    this.clientConfigDBService.getCategoryConfig().subscribe(
      (config) => {
        if (config) {
          this.categoryConfigVersion = config.version;
        }
      },
      () => {},
    );
    this.clientConfigDBService.getPointToCategoryMappingConfig().subscribe(
      (config) => {
        if (config) {
          this.pointToCategoryMappingConfigVersion = config.version;
        }
      },
      () => {},
    );
    this.clientConfigDBService.getPointToPointGroupMappingConfig().subscribe(
      (config) => {
        if (config) {
          this.pointToPointGroupMappingConfigVersion = config.version;
        }
      },
      () => {},
    );
    this.clientConfigDBService.getPointConfig().subscribe(
      (config) => {
        if (config) {
          this.pointConfigVersion = config.version;
        }
      },
      () => {},
    );
    this.clientConfigDBService.getClientConfig().subscribe(
      (config) => {
        if (config) {
          this.clientConfigVersion = config.version;
          this.acmobileAbout = {
            germanText: config.aCmobileAboutDe,
            frenchText: config.aCmobileAboutFr,
          };
        }
      },
      () => {},
    );
  }
}
